module.exports = __webpack_public_path__ + "static/media/HYUNDAI.49ffb00d.svg";